import CookiesConsent from './CookiesConsent.vue'

export default {
    'cookies-consent': CookiesConsent,
}

